export default "/dist/files/choix_animation_cartes_mysteres.a90414970c4da7a062ca7d87a639bb9a.svg";